import { motion } from "framer-motion";
import { useState } from "react";

export function FloatingInput({ label, name, value, onChange, error,badge }) {
    const [focused, setFocused] = useState(false);

    const isActive = focused || value;

    return (
        <div className="relative">
            <input
                name={name}
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                className={`w-full border rounded-lg px-6 pt-6 pb-2 text-sm outline-none ${error ? "border-red-500" : isActive ? "border-secondary-500" :'border-transparent'  
                    }`}
            />

            {/* FLOATING LABEL */}
            <motion.label
                initial={false}
                animate={{
                    top: isActive ? 6 : "50%",
                    x: isActive ? -2 : 15, // 👉 moves slightly right
                    scale: isActive ? 0.85 : 1,
                    y: isActive ? 0 : "-50%",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 8 }}
                className={`absolute left-4 bg-white px-1 pointer-events-none transition-colors duration-200
        ${error ? "text-red-500 text-xs" : isActive ? "text-black text-xs" : "text-gray-400 text-xs"}
    `}
            >
                {label}<span className="text-red-600">{badge}</span>
            </motion.label>

            {error && (
                <p className="text-red-500 text-xs mt-1">{error}</p>
            )}
        </div>
    );
}

export function FloatingTextarea({ label, name, value, onChange }) {
    const [focused, setFocused] = useState(false);
    const isActive = focused || value;

    return (
        <div className="relative">
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                rows={4}
                className={`w-full border text-sm rounded-lg px-6 pt-6 pb-2 outline-none ${isActive ? "border-secondary-500" :'border-transparent'}`}
            />

            <motion.label
                initial={false}
                animate={{
                    top: isActive ? 5 : "50%",
                    x: isActive ? -2 : 10,   //  same as input (right move)
                    scale: isActive ? 0.85 : 1,
                    y: isActive ? 0 : "-50%",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 15 }}
                className={`absolute left-4 bg-white px-1 pointer-events-none ${isActive ? "text-black text-xs" : "text-gray-400 text-xs"}`}
            >
                {label}
            </motion.label>
        </div>
    );
}
